function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgArrowStraight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 187 151"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#191919",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("path", {
  d: "M114.7 144.3l68.9-68.9-69.8-69.9"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M3.4 74.9h176.3"
})));

export default SvgArrowStraight;